<template>
  <div class="contact-thanks">
    <translate tag="h1" class="title">
      Thank you for contacting Pitchup.com
    </translate>
    <translate tag="p">
      All messages are read and we aim to respond within 2 working days, or much
      more quickly for urgent matters.
    </translate>
    <translate tag="p">
      Please ensure you add enquiries@pitchup.com to your safe email addresses
      to ensure you receive any replies.
    </translate>
  </div>
</template>

<script setup lang="ts">
const { $puScrollTo } = useNuxtApp()
onMounted(() => {
  $puScrollTo('.contact-thanks', { duration: 200, offset: -30 })
})
</script>

<style scoped>
.contact-thanks {
  margin: 1em 0;
  padding: 1em 1em 2em;
  background: #dcf1ff;
  border-radius: 1em;
}

h1 {
  font-size: 1.25em;
}
</style>
